import React from 'react';
import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Grid from '@mui/material/Unstable_Grid2';
import { Link } from 'gatsby-theme-material-ui';
import { useLanguageLink } from '../../hooks/useLanguageLink';
import { IntlProvider, FormattedMessage } from 'react-intl';
import ar from './ar.json';
import en from './en.json';
import { LocaleContext } from '../../../contexts/language';
import PropTypes from 'prop-types';

const languages = {
  ar,
  en
};

const PureDNBreadcrumbs = ( { paths } ) => {
  const l = useLanguageLink();
  const localeConfig = React.useContext(LocaleContext);
  const items = [...paths];
  const lastItem = items.pop();


  return (

    <IntlProvider locale={localeConfig?.lang} messages={languages[localeConfig?.lang] || languages.en}>
      <Grid container sx={{ mt:3, mb:3 }}>
        <Grid sm={12}>
          <Breadcrumbs aria-label="breadcrumb">
            {lastItem ? (
              <Link underline="hover" color="inherit" to={l('/')}>
                <FormattedMessage id={'breadcrumbs.home'} defaultMessage={'Home'}/>
              </Link>
            ) : (
              <Typography color="text.primary">
                <FormattedMessage id={'breadcrumbs.home'} defaultMessage={'Home'}/>
              </Typography>
            )}
            {items.map(( { name, path } ) => (
              <Link
                underline="hover"
                color="inherit"
                to={path}
                key={path}
              >
                {name}
              </Link>
            ))}
            <Typography color="text.primary">{lastItem.name}</Typography>
          </Breadcrumbs>
        </Grid>
      </Grid>

    </IntlProvider>
  );
};

export default PureDNBreadcrumbs;
export { PureDNBreadcrumbs };

PureDNBreadcrumbs.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired
  }))
};

PureDNBreadcrumbs.defaultProps = {
  paths: []
};